module.exports = __webpack_public_path__ + "assets/57bca4200f5b15cac20d9c9c978479a9.mp3";